import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { companyOnboardingKeys } from '@core/react-query/features/companyOnboarding/companyOnboardingKeys'
import { RequestTypes } from '../requestTypes'
import { companyKeys } from '../companyKeys'
import { OrganisationCompany } from '@core/entities/company'

export const useEditCompany = (
  options?: UseMutationOptions<
    OrganisationCompany,
    RequestErrorType,
    RequestTypes['editCompany']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...options,
    ...companyKeys.editCompany,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(companyKeys.getCompanies._def)
      queryClient.invalidateQueries(companyKeys.getCompanyDetails._def)
      queryClient.invalidateQueries({
        queryKey: companyOnboardingKeys.onboardingData({
          organisationId: variables.organisationId,
        }).queryKey,
      })

      options?.onSuccess?.(data, variables, context)
    },
  })
}
